import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Walkthrough from "@/pages/Walkthrough";
import WalkthroughSession from "@/pages/WalkthroughSession";
import Coach from "@/pages/Coach";
import CoachThread from "@/pages/CoachThread";
import CoachAvailability from "@/pages/CoachAvailability";
import CoachLogin from "@/pages/CoachLogin";
import CoachRegister from "@/pages/CoachRegister";
import CoachDashboard from "@/pages/CoachDashboard";
import CoachAdmin from "@/pages/CoachAdmin";
import CoachAdminFeedback from "@/pages/CoachAdminFeedback";
import LeaderLogin from "@/pages/LeaderLogin";
import LeaderRegister from "@/pages/LeaderRegister";
import LeaderStart from "@/pages/LeaderStart";
import LeaderPasswordResetRequest from "@/pages/LeaderPasswordResetRequest";
import LeaderPasswordResetConfirm from "@/pages/LeaderPasswordResetConfirm";
import LeaderConversations from "@/pages/LeaderConversations";
import MagicConsume from "@/pages/MagicConsume";
import Report from "@/pages/Report";
import Needs from "@/pages/Needs";
import NeedsSession from "@/pages/NeedsSession";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/walkthrough" element={<Walkthrough />} />
              <Route path="/walkthrough/:id" element={<WalkthroughSession />} />
              <Route path="/coach" element={<Coach />} />
              <Route path="/coach/my" element={<Coach />} />
              <Route path="/coach/login" element={<CoachLogin />} />
              <Route path="/coach/register" element={<CoachRegister />} />
              <Route path="/coach/dashboard" element={<CoachDashboard />} />
              <Route path="/coach/admin" element={<CoachAdmin />} />
              <Route path="/coach/admin/feedback" element={<CoachAdminFeedback />} />
              <Route path="/coach/availability" element={<CoachAvailability />} />
              <Route path="/coach/thread/:id" element={<CoachThread />} />
              <Route path="/auth/login" element={<LeaderLogin />} />
              <Route path="/auth/register" element={<LeaderRegister />} />
              <Route path="/auth/magic" element={<MagicConsume />} />
              <Route path="/auth/reset-request" element={<LeaderPasswordResetRequest />} />
              <Route path="/auth/reset" element={<LeaderPasswordResetConfirm />} />
              <Route path="/start" element={<LeaderStart />} />
              <Route path="/my/conversations" element={<LeaderConversations />} />
              <Route path="/report/:id" element={<Report />} />
              <Route path="/needs" element={<Needs />} />
              <Route path="/needs/:id" element={<NeedsSession />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
